
/*
 * Page | Decision Tree
 */

import { IModule } from "@sygnal/sse";
import { page } from "../engine/registry";


@page('/proto/tree')  
export class DecisionPage implements IModule {

  constructor() {
  }

  setup() {
        
  }

  exec() {

console.log("Decision Page");


  }

}
